// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"2440":"datadogProfiler","3581":"datadogRecorder","7076":"actioncable"}[chunkId] + "-" + {"2440":"1c39fead55a3cb21b71b","3581":"6df43f11fad9c6efc56c","7076":"f4fa5b933aa26461037a"}[chunkId] + ".chunk.js";
};